import { render } from "./vehicle-card.vue?vue&type=template&id=306e1903"
import script from "./vehicle-card.vue?vue&type=script&lang=js"
export * from "./vehicle-card.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__